export default {
  loading: "拼命加載中",
  totalData: "條數據",
  totalPrefix: "共計",
  download: "下載",
  downloadDetails: "下載數據明細",
  noData: "暫無數據",
  columns: {
    direction: "交易方向",
    currency: "幣種",
    quantity: "交易數量",
    price: "單價",
    legalTender: "法幣",
    amount: "總金額",
    txTime: "交易時間",
  },
  directions: {
    buy: "買入",
    sell: "賣出",
    unknown: "未知",
  },
};
